/**
 * Product autocomplete field
 */
 import 'awesomplete';

( () => {
    const inputs = document.querySelectorAll( '#quote_form #shiftr_form_22229_product, #quote_form #shiftr_form_20204_product, .product-autocomplete' )

    if ( !inputs ) {
        return
    }

    let imgList = new Object();

    function myItemFunc(text, input){
        return Awesomplete.$.create("li", {
        innerHTML: createItem(text,input),
        "aria-selected": "false"
        });
    }
      
    function createItem(text, input){
        var img = document.createElement("img");
        img.style.width = '32px';
        img.style.height = '32px';
        img.src = imgList[text.label] ?? '/wp-content/themes/shiftr/assets/images/missing.png';
        var html = input.trim() === "" ? text : text.replace(RegExp(Awesomplete.$.regExpEscape(input.trim()), "gi"), "<mark>$&</mark>");
        html = '<span>' + html + '</span>';
        return img.outerHTML + " " + html;
    }

    function initAutocomplete( input ) {
        const awesomplete = new Awesomplete(input, {
            list: [],
            item: myItemFunc
        });

        let products = []

        input.addEventListener("input", (event) => {
            const searchTerm = input.value;

            fetch(`/wp-admin/admin-ajax.php?action=woocommerce_product_search&search=${searchTerm}`)
                .then(response => response.json())
                .then(results => {
                    if (!results.success) {
                        return
                    }

                    products = results.data

                    products.forEach(product => {
                        if (product.image) {
                            imgList[product.name] = product.image;
                        }
                    })
                    awesomplete.list = products.map(({name}) => name)
                    awesomplete.evaluate()
                });
        });

        input.addEventListener('awesomplete-selectcomplete', event => {
            const product = products.find(({name}) => name === event.text.value)
            const thicknessField = document.querySelector('.field-autofill-thickness select')

            thicknessField.innerHTML = product.thickness?.sort((a,b) => {
                const aN = Number(a.replace(/mm/, ''))
                const bN = Number(b.replace(/mm/, ''))

                return aN - bN
            }).map(thickness => `
                <option>${thickness}</option>
            `).join('')
        })
    }

    inputs.forEach( initAutocomplete )
})();
